import React, {useState} from 'react'
import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    // Select,
    // Form,
    Input,
    // DatePicker
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
// const { Item } = Form;
const { Search } = Input;
// const { Option } = Select;
const { confirm } = Modal;

const ExhibitorsBilling = () => {
  const navigate = useNavigate()

  const [filterConfig, setFilterConfig] = useState({
    payment_id: "",
    type: "tenant",
    status: "open",
  })

  function ActionBtn(row) {
    const items = [
        {
            label: (
                <div onClick={()=> navigate('/edit-exhibitor-billing')}>
                    View Info
                </div>
            ),
            key: '1',
        },
        {
            label: (
                <div onClick={()=> navigate('/preview-exhibitor-billing')}>
                    Print Preview
                </div>
            ),
            key: '2',
        },
       
        {
            label: (
                <div style={{color: 'red'}} onClick={showDeleteConfirm}>
                    Delete
                </div>
            ),
            key: '3',
        },
    ];

    return (
      <>
        <span className='center'>
          <Dropdown
            menu={{
            items,
            }}
            trigger={['click']}
          >
            <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
              <Space>
                <MoreVert />
              </Space>
            </div>
          </Dropdown>
        </span>
      </>
    );
  }

  const showDeleteConfirm = () => {
      confirm({
        title: 'Are you sure delete this Property?',
        icon: <ExclamationCircleFilled />,
      //   content: 'Some descriptions',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
        },
        onCancel() {
        },
      });
    };

  
  const data = [
      {
        key: '1',
        billing_date: 'January 1 2024',
        due_date: 'February 1 2024',
        exhibitor_name: 'exhib 1',
        total_amount: '1 000',
        total_paid: '500',
        balance: '500',
      },
      {
        key: '2',
        billing_date: 'March 1 2024',
        due_date: 'April 1 2024',
        exhibitor_name: 'exhib 2',
        total_amount: '2 000',
        total_paid: '1200',
        balance: '800',
      },
      {
        key: '3',
        billing_date: 'May 1 2024',
        due_date: 'June 1 2024',
        exhibitor_name: 'exhib 3',
        total_amount: '10 000',
        total_paid: '3 000',
        balance: '7 000',
      },
      {
        key: '4',
        billing_date: 'July 1 2024',
        due_date: 'August 1 2024',
        exhibitor_name: 'exhib 4',
        total_amount: '15 000',
        total_paid: '5000',
        balance: '10 00',
      },
  ];

  const onSearch = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e.target.value || ''
      }
  ));
}; 
  return (
      <Layout className='page'>
          <Navbar navKey={'exhibitors_billing_nav'}/>
          <Layout className='content-container'>
            <Row>
              <Col span={14} className='header-container p-4'>
                  EXHIBITORS BILLINGS
              </Col>
              <Col span={10} className='pt-4'>
                <Row>
                  <Col span={14} className='p-4'>
                    <Search placeholder="input search text" size='medium' allowClear onSearch={onSearch} style={{ width: 250 }} />
                  </Col>
                  <Col span={10} className='p-4'>
                    <Button className='button-color btn-header' onClick={() => navigate('/add-exhibitor-billing')} type="primary">+ Add New Billing</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='page-content'>
              <Col span={24}>
                <AntDTable
                  tableHeaders={[
                    "Billing Date",
                    "Due Date",
                    "Exhibitor Name",
                    "Total Amount",
                    "Total Paid",
                    "Balance",
                  ]}
                  headerSelector={[
                    "billing_date",
                    "due_date",
                    "exhibitor_name",
                    "total_amount",
                    "total_paid",
                    "balance",
                  ]}
                  tableData={data}
                  ActionBtn={(row) => ActionBtn(row)}
                  withAction={true}
                  // loading={showLoader}
                  // isClickable={true}
                  // rowClickPath={"/patients/profile"}
                  tablePages={10}
                  // handleTableChange={handleTableChange}
                  // filterConfig={filterConfig}
                  // totalSize={totalSize}
                  isSearch={true}
                />
              </Col>
            </Row>
        </Layout>
      </Layout>
  )
}

export default ExhibitorsBilling
